import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-base/attendanceAddress/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-base/attendanceAddress/save',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-base/attendanceAddress/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const edit = params => request({
  url: '/api/mcc-base/attendanceAddress/update',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-base/attendanceAddress/remove',
  method: 'post',
  params: {
    ids,
  },
})

export default {
  getList,
  add,
  detail,
  edit,
  remove,
};
